import { render, staticRenderFns } from "./ReporteEmisionesAIG.vue?vue&type=template&id=60ea7616"
import script from "./ReporteEmisionesAIG.vue?vue&type=script&lang=js"
export * from "./ReporteEmisionesAIG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports